import type { CapabilitySlug } from "@/content/capabilities";
import type { IndustrySlug } from "@/content/industries";
import type { ServiceSlug } from "@/content/services";

export const routes = {
  home: "/",
  about: "/about",
  contact: "/contact",
  privacy: "/privacy",
  notFound: "/not-found",
  capabilities: {
    index: "/capabilities",
    detail: (slug: CapabilitySlug) => `/capabilities/${slug}`,
  },
  industries: {
    index: "/industries",
    detail: (slug: IndustrySlug) => `/industries/${slug}`,
  },
  // "/services" is the URL; the visible label everywhere is "Services". The
  // phrase "What We Build" belongs to the capability pages' offerings section.
  services: {
    index: "/services",
    detail: (slug: ServiceSlug) => `/services/${slug}`,
  },
  blog: {
    index: "/blog",
    detail: (slug: string) => `/blog/${slug}`,
  },
} as const;

type FlatRouteKey = "home" | "about" | "contact" | "privacy" | "notFound";

export type RouteHref =
  | (typeof routes)[FlatRouteKey]
  | typeof routes.capabilities.index
  | typeof routes.industries.index
  | typeof routes.services.index
  | typeof routes.blog.index;

// In-page anchor targets (element ids) — distinct from the routes above.
// These don't navigate; a link like `#${sectionIds.capabilities}` just
// scrolls the current page to the element with a matching `id`.
export const sectionIds = {
  capabilities: "capabilities",
} as const;
